export default "__VITE_ASSET__f420ae14__"